<template>
  <OrderFooter
    :buttonOptions="buttonOptions"
    @select="onOptionSelect"
  >
    <template #primaryAction>
      <BaseButton
        submitForm
        :disabled="!order.items.length"
        :loading="isLoadingDrawerStatus"
        @click="savingDraft = false"
        v-test="'order-checkout'"
      >
        {{ $t('global.actions.continue') }}
      </BaseButton>
    </template>
  </OrderFooter>
</template>

<script
  setup
  lang="ts"
>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRegisterOrderStore } from '@/modules/register/stores/order';
import { useRegisterStore } from '@/modules/register/stores/register';
import { useRegisterDrawerStore } from '@/stores/register-drawer';
import OrderFooter from '../Footer.vue';

const { order } = useRegisterOrderStore();
const { savingDraft } = storeToRefs(useRegisterStore());
const { isLoadingDrawerStatus } = storeToRefs(useRegisterDrawerStore());

const canSaveDraft = computed(() => {
  return !!((!order.id || order.draft) && order.items.length);
});

const { t } = useI18n();

const buttonOptions = computed<any[]>(() => {
  return [
    {
      icon: 'message-circle',
      label: order.note
        ? t('global.actions.edit_note')
        : t('global.actions.add_note'),
      value: 'note',
    },
    ...(canSaveDraft.value
      ? [
          {
            icon: 'save',
            label: t('register.save_draft'),
            value: 'draft',
            submitForm: true,
          },
        ]
      : []),
    {
      icon: 'delete',
      label: t('global.actions.cancel_sale'),
      value: 'reset',
      color: 'error',
    },
  ];
});

const onOptionSelect = (option: string) => {
  if (option === 'draft') {
    savingDraft.value = true;
  }
};
</script>
